import React, { createContext, useState, useEffect } from 'react';
import api from '../api/axios';

export const AuthContext = createContext();

const ALLOWED_ROLES = ['super_admin', 'admin', 'moderator', 'ministry', 'chief_doctor'];
const SESSION_DURATION_MS = 12 * 60 * 60 * 1000;

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAuth = () => {
            const token = localStorage.getItem('token');
            const savedUser = localStorage.getItem('user');
            const loginTime = localStorage.getItem('loginTime');

            if (token && savedUser && savedUser !== "undefined" && loginTime) {
                try {
                    if (Date.now() - parseInt(loginTime) > SESSION_DURATION_MS) {
                        console.warn("Сессия истекла (прошло 12 часов). Требуется повторный вход.");
                        throw new Error("Session Expired");
                    }

                    const parsedUser = JSON.parse(savedUser);

                    if (parsedUser && ALLOWED_ROLES.includes(parsedUser.role)) {
                        setUser(parsedUser);
                        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                    } else {
                        console.warn("Попытка несанкционированного доступа. Недостаточно прав.");
                        throw new Error("Access Denied: Invalid Role");
                    }
                } catch (error) {
                    console.error("Ошибка сессии:", error.message);
                    logoutLocally();
                }
            } else {
                logoutLocally();
            }
            setLoading(false);
        };

        checkAuth();
    }, []);

    const logoutLocally = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('loginTime');
        setUser(null);
    };

    const login = (userData, token) => {
        if (!userData || !ALLOWED_ROLES.includes(userData.role)) {
            alert("Доступ запрещен! Эта панель предназначена только для администраторов и руководства.");
            return false; 
        }

        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('loginTime', Date.now().toString());
        
        setUser(userData);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        return true; 
    };

    const logout = () => {
        logoutLocally();
        delete api.defaults.headers.common['Authorization'];
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};